import React, { useEffect, useState } from "react";
import LeadSelection from "./LeadSelection";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import MediumSelection from "./MediumSelection";
import MailTemplate from "./MailTemplate";
import marketingHubService from "../../Services/MarketingHubService";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";

const TemplateBulkSend = ({}) => {
  const [getLeadData, setGetLeadData] = useState({});
  const [getMedium, setGetMedium] = useState({});
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  const location = useLocation();
  const { template } = location.state || {};
  console.log(template);

  const content = template.content
  console.log(content)
  const subject = template.subject;

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const handleEditTemplate = () => {
    if (userRole === "Admin") {
      navigate(`/admin/update-textAndImage-template`, { state: { template } });
    } else if (userRole === "CMO") {
      navigate(`/cmo/update-textAndImage-template`, { state: { template } });
    }
  };

  const handleBulkSend = async () => {
    if (getMedium == 1) {
     
      const templateData = {
        content,
        subject,
        leadData: getLeadData,
      };

      try {
        const response = await marketingHubService.sendEmail(templateData);

        if (response.status === 200) {
          showSuccessToast("Mail sent Successfully");
        }
      } catch (error) {
        console.log(error.message);
        showErrorToast(
          error.message || "An error occurred while sending mail."
        );
      }
    }
  };
  useEffect(() => {
    console.log(getLeadData);
  }, [getLeadData]);

  useEffect(() => {
    console.log(getMedium);
  }, [getMedium]);
  return (
    <div className="pt-28 pb-5 bg-appGrayBackground ">
      <AdminAppBar />
      <ToastContainer />
      <div className="px-5">
        <div className="flex justify-between">
          <div className="flex gap-6">
            <svg
              onClick={handleBack}
              className="cursor-pointer"
              width="20"
              height="34"
              viewBox="0 0 22 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
                fill="#399E79"
              />
            </svg>
            <div>
              <h1 className="text-4xl font-semibold whitespace-nowrap ">
                {template.title}
              </h1>
            </div>
          </div>
          <div className="flex gap-5">
            <button
              onClick={handleEditTemplate}
              className="w-16  text-center text-white rounded-md bg-customGreen"
            >
              Edit
            </button>
            <button
              onClick={handleBulkSend}
              className="w-28  text-center text-white rounded-md bg-customGreen"
            >
              Bulk Send
            </button>
          </div>
        </div>
        <div className="mt-5 flex justify-between">
          <div className="flex flex-col gap-5 w-full mx-20">
            <LeadSelection method={setGetLeadData} />
            <MediumSelection method={setGetMedium} />
          </div>
          <div className="w-full">
            <MailTemplate template={template} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateBulkSend;
